<template>
  <v-card class="elevation-0">
    <v-card-title>
      <span class="headline" v-if="showHeader">Approvers</span>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search Here"></v-text-field>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :items="items"
        :headers="headers"
        :search="search"
        :footer-props="footerProps"
        :loading="loading"
      >
        <template v-slot:item.actions="{item}">
          <slot name="actions" v-bind:item="item"></slot>
        </template>
        <template v-slot:item.active="{item}">
          <!-- <slot name="actions" v-bind:item="item"></slot> -->
          <!-- <v-checkbox :input-value="item.active" value readonly></v-checkbox> -->
          <v-icon :color="item.active ? 'success' : 'grey'" dark>mdi-circle</v-icon>
        </template>

        <template v-slot:item.isNotedBy="{item}">
          <!-- <slot name="actions" v-bind:item="item"></slot> -->
          <v-checkbox :input-value="item.isNotedBy" value readonly></v-checkbox>
        </template>
      </v-data-table>

      <!-- <v-data-table
        :items="items"
        :headers="headers"
        :search="search"
        :footer-props="footerProps"
        :loading="loading"
        v-else-if="transType == 'PR'"
      >
        <template v-slot:item.actions="{item}">
          <slot name="actions" v-bind:item="item"></slot>
        </template>
        <template v-slot:item.active="{item}">
          <v-icon :color="item.active ? 'success' : 'grey'" dark>mdi-circle</v-icon>
        </template>
      </v-data-table>-->
    </v-card-text>
  </v-card>
</template>
<script>
const API_ENDPOINT = "/api/oApproverMember";
export default {
  props: {
    showHeader: {
      default: false,
      type: Boolean
    },
    transType: {
      default: "",
      type: String
    },
    selectedGroup: {
      default: () => {},
      type: Object
    }
  },
  data: () => ({
    items: [],
    headers: [],
    ecfHeaders: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Approver",
        value: "fullName",
        sortable: true
      },
      {
        text: "Order",
        value: "approverOrder",
        sortable: true
      },
      {
        text: "Noted By",
        value: "isNotedBy",
        sortable: true
      },
      {
        text: "Remarks",
        value: "remarks",
        sortable: true
      },
      {
        text: "Active",
        value: "active",
        sortable: true
      }
    ],
    prfHeaders: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Approver",
        value: "fullName",
        sortable: true
      },
      {
        text: "Approver Type",
        value: "approverType",
        sortable: true
      },
      {
        text: "Active",
        value: "active",
        sortable: true
      }
    ],
    loading: false,
    search: "",
    footerProps: {
      rowsPerPageItems: [20, 50]
    }
  }),
  methods: {
    // getAll() {
    //   this.loading = true;
    //   this.$axios
    //     .get(`${API_ENDPOINT}`)
    //     .then(({ data }) => {
    //       this.items = data;
    //     })
    //     .catch(({ response }) => {
    //       this.$toast.error(response.data.message);
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    getAll(groupCode, transType) {
      if (transType == "EC") {
        this.loading = true;
        this.headers = this.ecfHeaders;
        this.$axios
          .get(`${API_ENDPOINT}/ec/${groupCode}`)
          .then(({ data }) => {
            this.items = data;
          })
          .catch(({ response }) => {
            this.$toast.error(response.data.message);
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (transType == "PR") {
        this.loading = true;
        this.headers = this.prfHeaders;
        this.$axios
          .get(`${API_ENDPOINT}/pr/${groupCode}`)
          .then(({ data }) => {
            this.items = data;
          })
          .catch(({ response }) => {
            this.$toast.error(response.data.message);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.items = [];
        this.headers = [];
      }
    }
  },
  created() {
    if (typeof this.selectedGroup != "undefined")
      this.getAll(this.selectedGroup.approverGroupCode, this.transType);
    else {
      this.items = [];
      this.headers = [];
    }
  },
  mounted() {}
};
</script>
<style scoped>
.inactive {
  background-color: rebeccapurple;
}
</style>